import React from "react";
import ReactDOM from "react-dom";
import classes from "./export_grading_modal.module.css";
import util from "../../../styles/utilities.module.css";

const ExportGradingModal = ({ isOpen, backHandler, continueHandler, exportCount }) => {

    const { rubricCount, categoryCount, overallFeedback, generalFeedbacks  } = exportCount || {};

    if (!isOpen) {
        return null;
    }

    // Prepare additional text based on overall_feedback and true values in generalFeedbacks
    let overall_text = "";
    if (overallFeedback) {
        overall_text += "overall feedback, ";
    }
    let general_text = "";
    if (generalFeedbacks) {
        // Add ", key" for each true value in generalFeedbacks
        for (const [key, value] of Object.entries(generalFeedbacks)) {
            if (value) {
                general_text += `${key.toLowerCase()}, `;
            }
        }
    }
    let category_text = "";
    if (categoryCount === undefined || categoryCount === 0) {
        category_text = "";
    } else {
        category_text = `${categoryCount} category-specific feedback`;
    }

    return ReactDOM.createPortal(
        <div className={`${classes["modal-overlay"]} ${util.modalOverlay}`}>
            <div className={`${classes.modal} ${util.surface}`}>

                <p className={classes.exportParagraph}>
                    {`The following will be included in your exported file: ${overall_text}${rubricCount} rubric feedback, ${general_text}${category_text}.`}
                </p>

                <div className={classes.confirmationBtnContainer}>
                    <button onClick={backHandler} type="button" className={`${classes.leftBtn} ${util.btn} ${util['btn--ghost']}`}>{'Back'}</button>
                    <button onClick={continueHandler} type="button" className={`${classes.rightBtn} ${util.btn}`}>{'Continue'}</button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ExportGradingModal;
